import { render } from "./PeriodSelect.vue?vue&type=template&id=52c276c4"
import script from "./PeriodSelect.vue?vue&type=script&lang=js"
export * from "./PeriodSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__